/**
 * Auth API wrapper. Thin functions over the shared axios instance; each unwraps
 * `response.data` and lets `ApiRequestError` (thrown by the interceptor) bubble.
 */
import { api } from '@/utils/api';
import type { AuthResponse } from '@shared/types';

/**
 * Authenticate an existing user.
 * @returns The auth response containing `{ userId, token, email }`.
 */
export async function login(email: string, password: string): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/login', { email, password });
  return response.data;
}

/**
 * Register a new user and return an authenticated session.
 * @returns The auth response containing `{ userId, token, email }`.
 */
export async function register(email: string, password: string): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/register', { email, password });
  return response.data;
}

export default { login, register };
